<div *ngIf="navData" fxLayoutGap="10px" class="data-wrap pt-0" fxLayout="column">
    <div class="title mt-0" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon class="title-icon dark-blue {{ navData.data.class }}">{{ navData.data.icon }}</mat-icon>
        <div class="title-label dark-blue {{ navData.data.class }}" fxFlex="grow">{{ navData.data.title }}</div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <app-image-view
            [ngStyle]="{ minWidth: '110px' }"
            [media_id]="navData.data.resource.media"
            paddingBottom="70px"
        ></app-image-view>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span class="dark-blue res-title">{{ navData.data.resource.title }}</span>
            <!-- <div *ngIf="!navData.data.resource.price || navData.data.resource.price === 0" class="price-wrap">
                <div class="dark-blue-color">FREE!</div>
            </div> -->
        </div>
    </div>

    <div
        class="dates"
        *ngIf="navData.data.resource.occasion_dates && navData.data.resource.occasion_dates?.length == 1"
    >
        <mat-icon class="date-icon">today</mat-icon>
        <span>{{ navData.data.resource.occasion_dates[0].start_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
        <span>-</span>
        <span>{{ navData.data.resource.occasion_dates[0].end_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
        <span>{{ navData.data.resource.time_zone }}</span>
    </div>
    <div
        fxLayoutAlign="start start"
        fxLayoutGap="5px"
        fxLayout="column"
        *ngIf="navData.data.resource.occasion_dates?.length > 1"
    >
        <span i18n>Please select joining date</span>
        <mat-radio-group
            fxLayout="column"
            [formControl]="eventOccasionId"
            class="item"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
        >
            <mat-radio-button
                [disabled]="occ.selected || occ.ispassed"
                class="dates"
                *ngFor="let occ of navData.data.resource.occasion_dates"
                [value]="occ.id"
            >
                <mat-icon class="date-icon">today</mat-icon>
                <span>{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
                <span>-</span>
                <span>{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY HH:mm' }}</span>
                <span>{{ navData.data.resource.time_zone }}</span>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="desc">{{ navData.data.contentBody }}</div>
    <div *ngIf="!!navData.data.inputDesc" class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
        <span>{{ navData.data.inputDesc }}</span>
        <mat-form-field cdkTrapFocus appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
            <textarea
                cdkFocusInitial
                #taskInput
                matInput
                type="text"
                [formControl]="requestValue"
                placeholder="Message to the admin"
                i18n-placeholder
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="50"
                required
            ></textarea>
        </mat-form-field>
    </div>
</div>
<ng-container [ngTemplateOutlet]="actions"></ng-container>
<ng-template #actions>
    <div
        *ngIf="!!navData.data.actions?.length"
        class="action p-10"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="10px"
        [class.disableIt]="showGroupWork || showGroups"
    >
        <ng-container *ngFor="let action of navData.data.actions">
            <button
                [disabled]="
                    action.value == 1 && navData.data.resource.occasion_dates?.length > 1 && !eventOccasionId.value
                "
                fxFlex="0 0 auto"
                class="mobile-button positive {{ action.class }}"
                (click)="action.value ? onJoin() : onClose.emit(null)"
                mat-button
                i18n
            >
                {{ action.label }}
            </button>
        </ng-container>
    </div>
    <div *ngIf="showGroupWork" class="mt-1 p-10" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
        <div class="desc" i18n>
            Did you take this {{ navData.data.resource | resourceDefaultNameDisplay : false | async }} by yourself or
            with a group?
        </div>
        <div
            [class.disableIt]="showGroups"
            class="action"
            fxLayout="row-reverse"
            fxLayoutAlign="start center"
            fxLayoutGap="10px"
        >
            <button
                fxFlex="0 0 auto"
                class="mobile-button positive"
                (click)="action === 'done' ? onDone() : onClose.emit(null)"
                mat-raised-button
                i18n
            >
                By myself
            </button>
            <button fxFlex="0 0 auto" class="mobile-button negative" (click)="showGroups = true" mat-button i18n>
                With a group
            </button>
            <button
                fxFlex="0 0 auto"
                class="mobile-button negative"
                (click)="showGroupWork = false; (showGroups); action = null"
                mat-button
                i18n
            >
                Cancel
            </button>
        </div>
        <div class="w-100" *ngIf="showGroups" fxLayout="column" fxLayoutAlign="center end" fxLayoutGap="10px">
            <app-user-search-chips-display
                [user]="navData.data.user"
                (onUpdateSelectiedUsers)="participantUsers = $event"
            ></app-user-search-chips-display>
            <app-occasion-spend-time
                label="Time spent for this groupwork"
                i18n-label="@@spendTimeForThisGroupWork"
                [occasion]="navData.data.occasion"
                [formControl]="timeSpendControl"
            ></app-occasion-spend-time>
            <div class="action mt-1" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
                <button fxFlex="0 0 auto" class="mobile-button positive" (click)="submit()" mat-raised-button i18n>
                    Done
                </button>

                <button
                    fxFlex="0 0 auto"
                    class="mobile-button negative"
                    (click)="action === 'done' ? onDone() : onClose.emit(null)"
                    mat-button
                    i18n
                >
                    Close
                </button>
                <button fxFlex="0 0 auto" class="mobile-button negative" (click)="showGroups = false" mat-button i18n>
                    Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>
